import {
  configDvrAlarmEntriesAsync,
  configDvrChannelsAsync,
  createDvrDeviceAsync,
  deleteDvrDeviceAsync,
  getDvrAlarmEntriesAsync,
  getDvrChannelsAsync,
  getDvrDeviceByIdAsync,
  updateDvrDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateDvrDeviceAsync = () => useMutation(createDvrDeviceAsync);

export const useGetDvrDeviceByIdAsync = () =>
  useMutation(getDvrDeviceByIdAsync);

export const useUpdateDvrDeviceAsync = () => useMutation(updateDvrDeviceAsync);

export const useDeleteDvrDeviceAsync = () => useMutation(deleteDvrDeviceAsync);

export const useConfigDvrChannelsAsync = () =>
  useMutation(configDvrChannelsAsync);

export const useConfigDvrAlarmEntriesAsync = () =>
  useMutation(configDvrAlarmEntriesAsync);

export const useGetDvrChannelsAsync = () => useMutation(getDvrChannelsAsync);

export const useGetDvrAlarmEntriesAsync = () =>
  useMutation(getDvrAlarmEntriesAsync);
